function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 31,
  height: 31,
  rx: 15.5,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9998 17.3333C11.6332 17.3333 11.3194 17.2026 11.0585 16.9413C10.7972 16.6804 10.6665 16.3666 10.6665 16C10.6665 15.6333 10.7972 15.3193 11.0585 15.058C11.3194 14.7971 11.6332 14.6666 11.9998 14.6666C12.3665 14.6666 12.6803 14.7971 12.9412 15.058C13.2025 15.3193 13.3332 15.6333 13.3332 16C13.3332 16.3666 13.2025 16.6804 12.9412 16.9413C12.6803 17.2026 12.3665 17.3333 11.9998 17.3333ZM15.9998 17.3333C15.6332 17.3333 15.3194 17.2026 15.0585 16.9413C14.7972 16.6804 14.6665 16.3666 14.6665 16C14.6665 15.6333 14.7972 15.3193 15.0585 15.058C15.3194 14.7971 15.6332 14.6666 15.9998 14.6666C16.3665 14.6666 16.6805 14.7971 16.9418 15.058C17.2027 15.3193 17.3332 15.6333 17.3332 16C17.3332 16.3666 17.2027 16.6804 16.9418 16.9413C16.6805 17.2026 16.3665 17.3333 15.9998 17.3333ZM19.9998 17.3333C19.6332 17.3333 19.3192 17.2026 19.0578 16.9413C18.7969 16.6804 18.6665 16.3666 18.6665 16C18.6665 15.6333 18.7969 15.3193 19.0578 15.058C19.3192 14.7971 19.6332 14.6666 19.9998 14.6666C20.3665 14.6666 20.6805 14.7971 20.9418 15.058C21.2027 15.3193 21.3332 15.6333 21.3332 16C21.3332 16.3666 21.2027 16.6804 20.9418 16.9413C20.6805 17.2026 20.3665 17.3333 19.9998 17.3333Z",
  fill: "#111827"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 31,
  height: 31,
  rx: 15.5,
  stroke: "#D1D5DB"
});

function SvgMenuOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOrder);
export default __webpack_public_path__ + "static/media/menu_order.2c0b59ff.svg";
export { ForwardRef as ReactComponent };